import { FaroSkeleton, FaroTable, FaroTableProps } from '@faro/design-system';
import { ReactNode } from 'react';
import styles from './PublishedAgenticArtifactTable.module.scss';

export function PublishedAgenticArtifactTableSkeleton(props: FaroTableProps): ReactNode {
    const { className = '', ref, ...rest } = props;
    return (
        <FaroTable
            {...rest}
            ref={ref}
            className={`
                ${styles.table}
                ${className}
            `}
            appearance="bordered-minimally-interactive"
        >
            <thead>
                <tr>
                    <th>
                        <FaroSkeleton height="lg" />
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <FaroTable.Cell>
                        <FaroSkeleton height="lg" />
                    </FaroTable.Cell>
                </tr>
                <tr>
                    <FaroTable.Cell>
                        <FaroSkeleton height="lg" />
                    </FaroTable.Cell>
                </tr>
                <tr>
                    <FaroTable.Cell>
                        <FaroSkeleton height="lg" />
                    </FaroTable.Cell>
                </tr>
            </tbody>
        </FaroTable>
    );
}
